import { useEffect } from 'react'
import { useFormContext, type FieldValues } from 'react-hook-form'

export function StepValuesSync<T extends FieldValues>({
  onValuesChange,
}: {
  onValuesChange: (values: T) => void
}): null {
  const { watch } = useFormContext<T>()

  useEffect(() => {
    const subscription = watch((value) => {
      onValuesChange(value as T)
    })
    return () => subscription.unsubscribe()
  }, [watch, onValuesChange])

  return null
}
